// extracted by mini-css-extract-plugin
export default {"close":"RjZNz","tooltipWrapper":"t7SgY","tooltip":"Fi3Tn","icon":"_59if"};